import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Hvorfor registreringer av utenlandske turbusser i Norge?</h1>
        
        <div className="space-y-6 text-gray-600">
          <p>
            Fra 1. januar 2024 innførte Norge{' '}
            <a 
              href="https://www.regjeringen.no/no/aktuelt/regjeringen-vil-sikre-tydelige-rammer-for-lovlig-persontransportkabotasje-i-norge/id3019563/"
              className="text-blue-600 hover:text-blue-800 inline-flex items-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              nye regler
              <ExternalLink className="h-4 w-4 ml-1" />
            </a>
            {' '}for kontroll av persontransportkabotasje.
          </p>

          <p>
            Kabotasje er transport mellom to steder i en annen stat enn der transportøren hører hjemme. 
            Kabotasjekjøring i Norge skjer i praksis når en utenlandsk buss plukker opp og setter av 
            passasjerer innenfor Norges grenser.
          </p>
          
          <p>
            I dag kan en utenlandsk turbuss drive kabotasje i Norge i perioder på maksimalt 20 dager 
            sammenhengende, og maksimalt 30 dager totalt per kalenderår.
          </p>

          <p>
            Dessverre er det slik at utenlandske turbussoperatører finner Norge svært attraktivt for å 
            bedrive ulovlig kabotasjekjøring i. Svak håndheving og kontroll av myndighetene gir en lav 
            oppdagelsesrisiko, som igjen gjør at de utenlandske turbussoperatørene "tøyer strikken" i 
            jakten på lukrative kjøreoppdrag i Norge.
          </p>

          <p>
            Dette gir enorme negative ringvirkninger. I tillegg til at de utenlandske turbussjåførene 
            blir utsatt for systematisk sosial dumping, taper Norge betydelige avgiftsinntekter.
          </p>

          <p>
            Den norske turbussnæringen er i utvikling og henter seg inn igjen etter noen år med pandemi 
            og tyngre tider. Næringen er dessuten helt avgjørende i den norske transportberedskapen.
          </p>

          <p>
            Ulovlig turbusskabotasje begrenser den norske turbussnæringens vekstpotensial og påvirker 
            norsk transportberedskap negativt.
          </p>

          <p>
            For å kartlegge omfanget av utenlandske turbussers tilstedeværelse og omfang av kjøring i 
            Norge, har NHO Transport nå utviklet Turbussappen.
          </p>

          <p>
            Registreringer du gjør i appen vil være anonyme og det skal ikke dokumenteres sensitive 
            personopplysninger verken for brukerne eller de som registreres i denne appen.
          </p>

          <p>
            Datagrunnlaget som genereres her vil bli benyttet som dokumentasjon i foreningens dialog 
            med media og myndigheter. Alle registreringer er verdifulle bidrag til dette arbeidet.
          </p>

          <p>
            Har du spørsmål om appen, ta kontakt.
          </p>

          <p className="font-medium">
            Takk for at du bidrar til en trygg og seriøs turbussnæring!
          </p>
        </div>

        <div className="mt-8">
          <Link
            to="/login"
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            ← Tilbake til innlogging
          </Link>
        </div>
      </div>
    </div>
  );
}